import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as sendgridDomainSetupApi from '../../api/sendgridDomainSetup';

// Organization setup
export const useSetupOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendgridDomainSetupApi.setupOrganization,
    onSuccess: (data, variables) => {
      // Invalidate and refetch organization data
      queryClient.invalidateQueries({
        queryKey: ['organization', variables.organization_id],
      });
    },
    onError: (error) => {
      console.error('Error setting up organization:', error);
      throw error;
    },
  });
};

// Validate DNS
export const useValidateDns = () => {
  return useMutation({
    mutationFn: sendgridDomainSetupApi.validateDns,
    onError: (error) => {
      console.error('Error validating DNS:', error);
      throw error;
    },
  });
};

// Get organization status
export const useOrgStatus = (organizationId: string, enabled = true) => {
  return useQuery({
    queryKey: ['sendgrid-org-status', organizationId],
    queryFn: () => sendgridDomainSetupApi.getOrgStatus(organizationId),
    enabled: !!organizationId && enabled,
    refetchOnWindowFocus: false,
  });
};

// Get DNS records
export const useDnsRecords = (organizationId: string, enabled = true) => {
  return useQuery({
    queryKey: ['sendgrid-dns-records', organizationId],
    queryFn: () => sendgridDomainSetupApi.getDnsRecords(organizationId),
    enabled: !!organizationId && enabled,
    refetchOnWindowFocus: false,
  });
};

// Update organization email settings
export const useUpdateOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendgridDomainSetupApi.updateOrganization,
    onSuccess: (data, variables) => {
      // Invalidate and refetch organization data
      queryClient.invalidateQueries({
        queryKey: ['organization', variables.organization_id],
      });
    },
    onError: (error) => {
      console.error('Error updating organization:', error);
      throw error;
    },
  });
};

// Re-authenticate domain
export const useReauthenticateDomain = () => {
  return useMutation({
    mutationFn: sendgridDomainSetupApi.reauthenticateDomain,
    onError: (error) => {
      console.error('Error re-authenticating domain:', error);
      throw error;
    },
  });
};

// Check health
export const useCheckHealth = () => {
  return useQuery({
    queryKey: ['sendgrid-health'],
    queryFn: sendgridDomainSetupApi.checkHealth,
    refetchOnWindowFocus: false,
  });
};

// Change domain
export const useChangeDomain = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendgridDomainSetupApi.changeDomain,
    onSuccess: (data, variables) => {
      // Invalidate and refetch organization data
      queryClient.invalidateQueries({
        queryKey: ['organization', variables.organization_id],
      });
    },
    onError: (error) => {
      console.error('Error changing domain:', error);
      throw error;
    },
  });
};
